import React from 'react'
import compose from 'recompose/compose'
import { connect as connectStaticText } from '../../StaticText/connect'
import StaticTextToHtml from '../../StaticTextToHtml/index'
import Expandable from '../../Expandable/Expandable'
import { DISPLAY_SETTINGS } from '../../../services/url/constants'
import AutoplaySettings from './AutoplaySettings'
import MinimizeSpotlightSettings from './MinimizeSpotlightSettings'
import VideoPlayerInfo from './VideoPlayerInfo'
import AIVisibilitySettings from './AIVisibilitySettings'
import AIVideoGuideSettings from './AIVideoGuideSettings'
import AIPersonalitySettings from './AIPersonalitySettings'

const DisplaySettings = (props) => {
  const { staticText } = props
  return (
    <Expandable
      id={DISPLAY_SETTINGS}
      className="my-account-settings-V2__settings-container"
      variant="setting"
      header={staticText.getIn(['data', 'displaySettings'])}
      description={() => (
        <StaticTextToHtml staticText={staticText} staticTextKey={['data', 'displaySettingsDescription']} />
      )}
    >
      <MinimizeSpotlightSettings />
      <VideoPlayerInfo />
      <AutoplaySettings />
      <AIVisibilitySettings />
      <AIVideoGuideSettings />
      <AIPersonalitySettings />
    </Expandable>
  )
}

export default compose(connectStaticText({ storeKey: 'myAccountSettingsV2' }))(
  DisplaySettings,
)
